export const countryConfigPL = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 2,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'rowery-i-hulajnogi',
    carCollection: 'samochody'
  },
  'landing-custom-products': {
    proCustomization: 'pro-3d-2',
    design: 'pro-3d-2',
    logo: 'pro-3d-2'
  }
};
